<app-image-panel  [formService]="itemView['dynamicFormService']"></app-image-panel>
<div class="panels-container">
  <app-sudski-registar-panel></app-sudski-registar-panel>
  <app-oib-service-panel></app-oib-service-panel>
</div>
<ntap-prime-common-itemview #itemView></ntap-prime-common-itemview>
